import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RatingDisplay from '../Reviews/RatingDisplay';
import { withTranslation } from 'react-i18next';
import { productImpressionGA, productClickGA } from '../../js/analytics';

import { showActiveTripPopUp } from '../../actions/trip';

import {
  getPricePerPax,
  getPriceByPax,
  getDiscPricePerPax,
  createDiscountLabel,
  createPriceLabel,
  findMinMaxPaxRate
} from '../../js/utility';

import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';
import bookIcon from '../../images/icons/icon_32_bookingprocessorange.png';
import starIcon from '../../images/icons/icon_reviewstar_inactive.png';

class TripItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { trip } = this.props;
    productImpressionGA(trip.id, trip.title, trip.vendor);
  }

  render() {
    const { trip, showActiveTripPopUp, direct, showDuration, handleClick, t } = this.props;
    const isByAge = trip.trip_price.price_type === 'by_age'; // disabled in CMS
    const isPerTrip = trip.trip_price.is_per_trip; // disabled in CMS
    const isByPax = trip.trip_price.price_type === 'by_pax';

    let priceByPax = getPricePerPax(trip.trip_price);
    const pricePerPax = getPricePerPax(trip.trip_price, {
      pax_max: trip.pax_max
    });
    const discPricePerPax = getDiscPricePerPax(
      trip.trip_price,
      { pax_max: trip.pax_max },
      trip.trip_discount
    );

    const lowestAdultPax = findMinMaxPaxRate(trip.trip_price.adult_rate, 'min');

    // Include insurance, SST, & service fee
    const insurance = parseFloat(process.env.INSURANCE_AMOUNT);
    const sstPercentage = parseFloat(process.env.TAX_PERCENTAGE)/100;
    const serviceFee = parseFloat(process.env.SST_PERCENTAGE)/100;
    priceByPax.adult = priceByPax.adult + (insurance * lowestAdultPax);
    priceByPax.adult = priceByPax.adult + (priceByPax.adult * serviceFee);
    priceByPax.adult = priceByPax.adult + (priceByPax.adult * sstPercentage);

    let priceStr = createPriceLabel(priceByPax, discPricePerPax);
    let discountStr = createDiscountLabel(trip.trip_discount);

    if (trip.slug === 'ford-ranger-training-experience-sabah'){
      priceStr = 'From ' + priceStr.adult + ' per vehicle';
    }
    else if (trip.slug === 'a-trip-through-nature-at-gunung-jerai'){
      priceStr = 'From ' + priceStr.adult + '<br> (Up to 4 pax)';
    }
    else if (isPerTrip) {
      priceStr = t('gen:pricePerTrip', {
        price: priceStr
      });
    } else if (isByAge) {
      priceStr = t('gen:fromPricePerPax', {
        price: priceStr.adult
      }).concat('**');
    } else if (isByPax) {
      priceStr = t('gen:fromPriceByPax', {
        price: priceStr.adult,
        minPax: trip.pax_min
      });
    } else {
      priceStr = t(
        `gen:${trip.pax_min > 1 ? 'fromPricePerPax' : 'pricePerPax'}`,
        {
          price: priceStr
        }
      ).concat(trip.pax_min > 1 ? '*' : '');
    }

    return (
      <div className='trip-item'>
        <div className='fe-trip-item-info-main'>
          {discountStr ? (
            <div className='fe-discount-label'>
              {t('gen:discountOff', { discountAmount: discountStr })}
            </div>
          ) : null}
          {/* {trip.byor ? (
            <div className='trip-item-byoc-icon'>
              <img src={iconBYOC} alt='' />
            </div>
          ) : null} */}
          {(trip.upcoming)? (
            <div className='trip-item-50-off text-coming-soon'>
              <div className='trip-item-50-off-text'>
              COMING SOON
              </div>
            </div>
          ) : null}

          {(trip.slug === 'marine-life-of-mabul' || trip.slug === 'escape-to-kapalai-paradise' || trip.slug === 'tabin-wildlife-safari-adventure' || trip.slug === 'island-retreat-in-mantanani')? (
            <div className='trip-new-label'>
              <img src={starIcon} />
              <div className='trip-new-label-text'>
                NEW
              </div>
            </div>
          ) : null}

          {trip.slug === 'ford-ranger-training-experience-sabah' || trip.slug === 'ford-ranger-training-experience' ? (
            // <div className='trip-item-50-off'>
            //   {/* <img src={bookIcon} alt='' /> */}
            //   <div className='trip-item-50-off-text'>
            //     50%
            //   </div>
            //   <div className='trip-item-50-off-text'>
            //     OFF
            //   </div>
            // </div>
            null
          ) : null}
          <Link
            onClick={() => {productClickGA(trip.id, trip.title, trip.vendor); handleClick;}}
            to={`/trips/${trip.slug}`}
            className={`trip-item-link ${!direct ? 'mobile-only' : ''}`}
          >
            <div className='fe-u-thumb-4by3 fe-rounded'>
              <img
                className='trip-item-img'
                src={trip.image_cover.thumbnail_url}
                alt=''
              />
              <div className='trip-item-byor-img' />
            </div>
          </Link>
          {direct ? null : (
            <div className='fe-u-thumb-4by3 fe-rounded desktop-only'>
              <img
                onClick={() => {showActiveTripPopUp(trip.id, true); handleClick();}}
                className='trip-item-img'
                src={trip.image_cover.thumbnail_url}
                alt=''
              />
            </div>
          )}
          <div className='trip-item-info'>
            <span className='trip-item-loc'>{trip.location_text}</span>
            {showDuration ? (
              <span className='trip-item-duration'>{trip.duration}</span>
            ) : null}
          </div>
          <Link
            onClick={() => productClickGA(trip.id, trip.title, trip.vendor)}
            to={`/trips/${trip.slug}`}
            className={`trip-item-link ${!direct ? 'mobile-only' : ''}`}
          >
            <h3 className='trip-item-title'>{trip.title}</h3>
          </Link>
          {direct ? null : (
            <h3
              className='trip-item-title desktop-only'
              onClick={() => {showActiveTripPopUp(trip.id, true); handleClick();}}
            >
              {trip.title}
            </h3>
          )}
        </div>
        <div className='fe-trip-item-btm'>
          {/* <RatingDisplay
            rating={trip.rating}
            showTotal
            totalRatings={trip.reviews}
          /> */}
          <div
            className='trip-item-price'
            dangerouslySetInnerHTML={{
              __html: priceStr
            }}
          />
        </div>
      </div>
    );
  }
}

TripItem.propTypes = {
  trip: PropTypes.object.isRequired,
  showActiveTripPopUp: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  direct: PropTypes.bool.isRequired,
  showDuration: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

TripItem.defaultProps = {
  direct: false,
  showDuration: true
};

const mapDispatchToProps = {
  showActiveTripPopUp
};

export default withTranslation()(
  connect(
    null,
    mapDispatchToProps
  )(TripItem)
);
